import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Link from 'react-router-dom/Link';
import Tab from '@material-ui/core/Tab';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  href: PropTypes.string.isRequired,
};

const styles = () => ({
  root: {
    minWidth: 'initial',
  },
});

class LinkTab extends React.Component {
  renderLink = React.forwardRef((linkProps, ref) => (
    <Link to={linkProps.href} {...linkProps} innerRef={ref} />
  ));

  render() {
    return (
      <Tab
        component={this.renderLink}
        {...this.props}
      />
    );
  }
}

LinkTab.propTypes = propTypes;

export default withStyles(styles)(LinkTab);
